import React from "react"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"

import HERO_BANNER_DATA from "../data/value-pack/herobanner"
import CAROUSEL_1 from "../data/value-pack/1Carousel"
import CAROUSEL_2 from "../data/value-pack/2Carousel"
import CAROUSEL_3 from "../data/value-pack/3Carousel"
import CAROUSEL_4 from "../data/value-pack/4Carousel"
import CAROUSEL_5 from "../data/value-pack/5Carousel"
import CAROUSEL_6 from "../data/value-pack/6Carousel"
import CAROUSEL_7 from "../data/value-pack/7Carousel"
import FAQ_DATA from "../data/value-pack/faq"

import Layout from "../components/layout"
import "../css/main.css"
import { fireGtmEvent } from "../utils/functions"

const ContentWrapper = styled.div`
  max-width: 625px;
  margin-bottom: 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 3em;

  @media only screen and (max-width: 720px) {
    width: 90%;
    margin: 2em auto;

    #title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 10px;
    }
    
    #subtitle {
      font-size: 16px;
      line-height: 20px;
    }
  }
`

const TextContentWrapper = styled.div`
  width: 90%;
  margin: 0 16px 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`

const ValuePackPage = () => {
  return (
    <Layout title="Shop Value Pack from RM10"
            description="Browse our curated selections of fruits, seafoods, meats and other kitchen essentials."
    bannerData={HERO_BANNER_DATA}>
      <ContentWrapper>
        <TitleWrapper>
          <Title
            accessible
            inverted={false}
            textAlign="left"
            type="h1"
            customProperties={{id:'title'}}
          >
            Shop Value Packs from RM10
          </Title>
          <Title
            accessible
            inverted={false}
            textAlign="left"
            theme="AIRASIA_CLASSIC"
            type="h2"
            customProperties={{id:'subtitle'}}
          >
            Get more value with Value Packs!
          </Title>
        </TitleWrapper>
      </ContentWrapper>
      {/*<ContentWrapper>*/}
      {/*  <Carousel*/}
      {/*    accessible*/}
      {/*    allowLocaleFormat={true}*/}
      {/*    data={CAROUSEL_1.data}*/}
      {/*    heading={CAROUSEL_1.heading}*/}
      {/*    isHideFooter={false}*/}
      {/*    isLoading={false}*/}
      {/*    templateType="productCard"*/}
      {/*  />*/}
      {/*</ContentWrapper>*/}
      {/*<ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_2.data}
          heading={CAROUSEL_2.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>*/}
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_3.data}
          heading={CAROUSEL_3.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_4.data}
          heading={CAROUSEL_4.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_5.data}
          heading={CAROUSEL_5.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      {/*<ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_6.data}
          heading={CAROUSEL_6.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_7.data}
          heading={CAROUSEL_7.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>*/}
      <TextContentWrapper>
        <FAQ
          titleMarginBottom="normal"
          titleType="h3"
          title=""
          data={FAQ_DATA}
        />
      </TextContentWrapper>
    </Layout>
  )
}
export default ValuePackPage
